import React, {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import classes from "./PaymentModes.module.css";
import SelectInput from "../../framework/SelectInput";
import { getPaymentModes } from "../../services/payment-services";
import TextInput from "../../framework/TextInput";
import DateInput from "../../framework/date/DateInput";
import GlobalContext from "../../framework/GlobalContext";
import { _ } from "ag-grid-community";
import { isEmpty } from "../../utils/utils";
import moment from "moment";
import { getISODateTime } from "../../utils/momentUtils";
// import { PENDING } from "../payments";

// const PAYMENT_MODE_IDS = {
//   PAYMENT_MODE: 0,
//   PAYMENT_MODE_REF_ID: 1,
//   PAYMENT_MODE_PAYEE_NAME: 2,
//   PAYMENT_MODE_BANK_NAME: 3,
//   PAYMENT_MODE_PAYMENT_DATE: 4,
// };

const PaymentModes = forwardRef(
  (
    {
      showsIn,
      showPendingMode = false,
      label = "Payment Mode",
      defaultPaymentModeId = "",
      defaultPaymentRefId = "",
      defaultPayeeName = "",
      defaultPayeeBankName = "",
      defaultPaymentDate = null,
      editPayeeBankName = true,
      showPaymentModeOnly = false,
      disabled = false,
      markers = {},
      onFocus = () => {},
      getPaymentMode = () => {},
      getPaymentRefId = () => {},
      getPayeeName = () => {},
      getPayeeBankName = () => {},
      getPaymentDate = () => {},
    },
    ref
  ) => {
    const { setCurrentComponent } = useContext(GlobalContext);

    const [paymentModes, setPaymentModes] = useState([]);
    const [selectedPaymentMode, setSelectedPaymentMode] = useState();

    const [showPaymentRefId, setShowPaymentRefId] = useState(false);
    const [showPayeeName, setShowPayeeName] = useState(false);
    const [showPayeeBankName, setShowPayeeBankName] = useState(false);
    const [showPaymentDate, setShowPaymentDate] = useState(false);

    const [paymentModeRefId, setPaymentModeRefId] = useState("");
    const [paymentModePayeeName, setPaymentModePayeeName] = useState("");
    const [paymentModePayeeBankName, setPaymentModePayeeBankName] =
      useState("");
    const [paymentModePaymentDate, setPaymentModePaymentDate] = useState(null);

    const toggleInputs = useCallback(
      (modeId) => {
        if (showPaymentModeOnly) {
          modeId = "paymentModeOnly";
        }
        switch (modeId) {
          case "1SF":
          case "2SF":
          case "8SF":
          case "paymentModeOnly":
            setShowPaymentRefId(false);
            setShowPayeeName(false);
            setShowPayeeBankName(false);
            setShowPaymentDate(false);
            setPaymentModeRefId("");
            setPaymentModePayeeName("");
            setPaymentModePayeeBankName("");
            setPaymentModePaymentDate(null);
            break;
          case "3SF":
          case "4SF":
          case "5SF":
            setShowPaymentRefId(true);
            setShowPayeeName(true);
            setShowPayeeBankName(true);
            setShowPaymentDate(true);
            setPaymentModeRefId(defaultPaymentRefId || "");
            setPaymentModePayeeName(defaultPayeeName || "");
            setPaymentModePayeeBankName(defaultPayeeBankName || "");
            setPaymentModePaymentDate(
              (defaultPaymentDate &&
                moment(defaultPaymentDate).format("DD/MM/YYYY")) ||
                null
            );
            break;
          default:
            setShowPaymentRefId(true);
            setShowPayeeName(false);
            setShowPayeeBankName(false);
            setShowPaymentDate(false);
            setPaymentModeRefId(defaultPaymentRefId);
            setPaymentModePayeeName("");
            setPaymentModePayeeBankName("");
            setPaymentModePaymentDate(null);
            break;
        }
      },
      [
        defaultPayeeBankName,
        defaultPayeeName,
        defaultPaymentDate,
        defaultPaymentRefId,
        showPaymentModeOnly,
      ]
    );
    const fetchMarker = (key, default_marker) => {
      switch (key) {
        case 0:
          return "payment-modes-select";
        case 1:
          return "payment-ref-id";
        case 2:
          return "payee-name";
        case 3:
          return "bank-name";
        case 4:
          return "payment-date";
        default:
          return default_marker;
      }
    };
    const fetchNextMarker = (current_marker, default_marker) => {
      let nextMarker = null;
      if (showPaymentRefId && 1 > current_marker) {
        nextMarker = 1;
      } else if (showPayeeName && 2 > current_marker) {
        nextMarker = 2;
      } else if (showPayeeBankName && 3 > current_marker) {
        nextMarker = 3;
      } else if (showPaymentDate && 4 > current_marker) {
        nextMarker = 4;
      }
      return fetchMarker(nextMarker, default_marker);
    };
    const fetchPrevMarker = (current_marker, default_marker) => {
      let prevMarker = null;
      if (showPayeeBankName && 3 < current_marker) {
        prevMarker = 3;
      } else if (showPayeeName && 2 < current_marker) {
        prevMarker = 2;
      } else if (showPaymentRefId && 1 < current_marker) {
        prevMarker = 1;
      } else if (0 < current_marker) {
        prevMarker = 0;
      }
      return fetchMarker(prevMarker, default_marker);
    };
    const changePaymentModeHandler = useCallback(
      (e, option) => {
        setSelectedPaymentMode(option);
        toggleInputs(option.paymentModeId);
        getPaymentMode(option);
      },
      [getPaymentMode, toggleInputs]
    );
    useEffect(() => {
      getPaymentModes(showsIn ? `showsIn=${showsIn}` : "").then((response) => {
        if (response?.length && !showPendingMode) {
          response = response.filter((m) => m.paymentModeId !== "8SF");
        }
        setPaymentModes(response || []);
      });
    }, [showPendingMode, showsIn]);
    useEffect(() => {
      if (!isEmpty(defaultPaymentModeId) && paymentModes?.length) {
        const selectedMode = paymentModes.find(
          (mode) => mode.paymentModeId === defaultPaymentModeId
        );
        if (selectedMode) {
          setSelectedPaymentMode(selectedMode);
          toggleInputs(defaultPaymentModeId);
        }
      }
    }, [defaultPaymentModeId, paymentModes, toggleInputs]);
    return (
      <div className={classes["payment-modes"]}>
        <div
          className={classes["payment-modes-field"]}
          style={{ maxWidth: showPaymentModeOnly ? "100%" : "300px" }} //alston
        >
          <SelectInput
            id={"payment-modes-select"}
            label={label}
            ref={ref}
            options={paymentModes}
            isOptionEqualToValue={(option, value) => {
              return option.paymentModeId === value.paymentModeId;
            }}
            disabled={disabled}
            getOptionLabel={(option) => {
              return option.paymentMode;
            }}
            onFocus={(e) => {
              setCurrentComponent("payment-modes-select");
              onFocus(e);
            }}
            onChange={changePaymentModeHandler}
            value={selectedPaymentMode}
            markers={JSON.stringify({
              altUp: markers?.altUp || "",
              altDown: markers?.altDown || "",
              up: markers?.up || "",
              down: markers?.down || "",
              left: markers?.left || "",
              right: fetchNextMarker(0, markers?.right || ""),
            })}
          />
        </div>
        {showPaymentRefId && (
          <div className={classes["payment-modes-field"]}>
            <TextInput
              id="payment-ref-id"
              label={
                selectedPaymentMode?.paymentModeId === "3SF"
                  ? "Cheque Number"
                  : "Txn Id"
              }
              onFocus={(e) => {
                setCurrentComponent("payment-ref-id");
              }}
              onChange={(e) => {
                setPaymentModeRefId(e.target.value);
                _.debounce(() => {
                  getPaymentRefId(e.target.value);
                }, 300)();
              }}
              value={paymentModeRefId}
              inputProps={{
                "data-markers": JSON.stringify({
                  altUp: markers?.altUp || "",
                  altDown: markers?.altDown || "",
                  up: markers?.up || "",
                  down: markers?.down || "",
                  left: fetchPrevMarker(1, markers?.left || ""),
                  right: fetchNextMarker(1, markers?.right || ""),
                }),
              }}
            />
          </div>
        )}
        {showPayeeName && (
          <div className={classes["payment-modes-field"]}>
            <TextInput
              id="payee-name"
              label="Payee Name"
              onFocus={(e) => {
                setCurrentComponent("payee-name");
              }}
              value={paymentModePayeeName}
              onChange={(e) => {
                setPaymentModePayeeName(e.target.value);
                _.debounce(() => {
                  getPayeeName(e.target.value);
                }, 300)();
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  altUp: markers?.altUp || "",
                  altDown: markers?.altDown || "",
                  up: markers?.up || "",
                  down: markers?.down || "",
                  left: fetchPrevMarker(2, markers?.left || ""),
                  right: fetchNextMarker(2, markers?.right || ""),
                }),
              }}
            />
          </div>
        )}
        {showPayeeBankName && (
          <div className={classes["payment-modes-field"]}>
            <TextInput
              id="bank-name"
              label="Bank Name"
              value={paymentModePayeeBankName}
              onFocus={(e) => {
                setCurrentComponent("bank-name");
              }}
              onChange={(e) => {
                setPaymentModePayeeBankName(e.target.value);
                _.debounce(() => {
                  getPayeeBankName(e.target.value);
                }, 300)();
              }}
              InputProps={{ readOnly: !editPayeeBankName }}
              inputProps={{
                "data-markers": JSON.stringify({
                  altUp: markers?.altUp || "",
                  altDown: markers?.altDown || "",
                  up: markers?.up || "",
                  down: markers?.down || "",
                  left: fetchPrevMarker(3, markers?.left || ""),
                  right: fetchNextMarker(3, markers?.right || ""),
                }),
              }}
            />
          </div>
        )}
        {showPaymentDate && (
          <div className={classes["payment-modes-field"]}>
            <DateInput
              id="payment-date"
              label="Payment Date"
              value={paymentModePaymentDate}
              onFocus={(e) => {
                setCurrentComponent("payment-date");
              }}
              onChange={(e, value) => {
                setPaymentModePaymentDate(value);
              }}
              onBlur={(e, date, validDate) => {
                if (validDate) {
                  getPaymentDate(getISODateTime(date));
                } else {
                  getPaymentDate(null);
                }
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  altUp: markers?.altUp || "",
                  altDown: markers?.altDown || "",
                  up: markers?.up || "",
                  down: markers?.down || "",
                  left: fetchPrevMarker(4, markers?.left || ""),
                  right: fetchNextMarker(4, markers?.right || ""),
                }),
              }}
            />
          </div>
        )}
      </div>
    );
  }
);

export default PaymentModes;
